import { render, staticRenderFns } from "./invicetable.vue?vue&type=template&id=4f6bb790&scoped=true"
import script from "./invicetable.vue?vue&type=script&lang=js"
export * from "./invicetable.vue?vue&type=script&lang=js"
import style0 from "./invicetable.vue?vue&type=style&index=0&id=4f6bb790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bb790",
  null
  
)

export default component.exports